import { AxiosError } from 'axios';
import { getActiveGearsUrl } from 'constants/urls';
import { UserContext } from 'context/UserContext';
import { useSWRAxios } from 'hooks/useSWRAxios';
import { GEARS } from 'pages/Gear/types';
import { useContext } from 'react';

export const useActiveGears = () => {
    const { user } = useContext(UserContext);
    const url = getActiveGearsUrl(user?.id || '');
    const { data, ...restProperties } = useSWRAxios<
        GEARS[],
        AxiosError<{ message: string }>,
        {
            fallbackData: GEARS[];
        }
    >(url, { fallbackData: [] });

    return {
        ...restProperties,
        activeGears: data
    };
};
